import { render, staticRenderFns } from "./ProformDataTable.vue?vue&type=template&id=518f35af&scoped=true"
import script from "./ProformDataTable.vue?vue&type=script&lang=js"
export * from "./ProformDataTable.vue?vue&type=script&lang=js"
import style0 from "./ProformDataTable.vue?vue&type=style&index=0&id=518f35af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518f35af",
  null
  
)

export default component.exports